export default __webpack_public_path__ + "static/media/pauseicon.1273390e.svg";